<template>
  <div class="outer-box max-w-xl">
    <h4>Bypass Chat Widget Block (A2P)</h4>

    <div class="inner-box" style="text-align: left; width: 500px">
      <b-alert show variant="warning" class="text-left mb-3">
        Use this for locations where the GHL chat widget is confirmed installed but
        cannot be auto-detected (e.g. Wix HtmlComponent, Cloudflare IUAM, strict
        IP blocks).
      </b-alert>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />

      <div class="d-flex mt-4" style="gap: 12px">
        <button
          class="btn btn-success"
          :disabled="processing || !locationId"
          @click="setBypass(true)"
        >
          <moon-loader v-if="processing && action === 'enable'" :loading="true" size="21px" color="#fafafa" />
          <span v-else>Enable Bypass</span>
        </button>

        <button
          class="btn btn-danger"
          :disabled="processing || !locationId"
          @click="setBypass(false)"
        >
          <moon-loader v-if="processing && action === 'disable'" :loading="true" size="21px" color="#fafafa" />
          <span v-else>Disable Bypass</span>
        </button>
      </div>

      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div><!-- /inner-box -->
  </div><!-- /outer-box -->
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      action: null,
      response: null,
    };
  },
  methods: {
    async setBypass(enabled) {
      try {
        this.processing = true;
        this.action = enabled ? "enable" : "disable";
        this.response = null;

        const result = await SaasService.editTwilioAccount(this.locationId, {
          key: "campaignDetails",
          value: { bypassChatWidgetBlock: enabled },
        });

        this.response = {
          ok: true,
          bypassChatWidgetBlock: enabled,
          message: `Chat widget block ${enabled ? "bypassed" : "re-enabled"} for location ${this.locationId}`,
          ...result.data,
        };
      } catch (err) {
        this.response = err?.response?.data || { error: err.message };
      } finally {
        this.processing = false;
        this.action = null;
      }
    },
  },
};
</script>
